import styled from 'styled-components';

export const ColoredDotWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 12px;
`;

export const StyledDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${(props) => props.backgroundColor};
  margin-right: 5px;
  margin-left: 5px;
`;

export const StyledDotTitle = styled.div`
  color: rgba(14, 26, 64, 0.45);
  line-height: 1;
  ::before {
    content: '${(props) => props.title}';
  }
`;

export const FlexRowCenter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
